// The thread pane's follow control (ThreadViewModel.refreshFollowState / toggleFollow, Windows
// ThreadPaneViewModel): TRI-STATE — `null` draws NO control (the pane paints before the server has
// answered, and a "Seguir" corrected a frame later lies), `true` / `false` say what a press does.
// The toggle is optimistic: flip now, roll back if the server refuses. The server auto-follows a
// thread on reply (ThreadAutoFollow), so the state is re-read a moment after the reader replies.

export type FollowState = boolean | null;

/** Windows' delay before re-reading after a reply (the server's auto-follow lands first). */
export const REREAD_AFTER_REPLY_MS = 1500;

/** The control's label key — the ACTION, like the Mac and Windows buttons; null = draw nothing. */
export function labelKey(state: FollowState): string | null {
  if (state === null) return null;
  return state ? 'threads.unfollow' : 'threads.follow';
}

/** The optimistic next state, or null when there is nothing to toggle yet. */
export function toggled(state: FollowState): boolean | null {
  return state === null ? null : !state;
}

/**
 * A server answer applied to what is on screen: a known answer replaces it; "could not ask" (null)
 * keeps what was shown — never guesses "not following" (SyncEngine.threadFollowState).
 */
export function afterRead(shown: FollowState, answer: FollowState): FollowState {
  return answer === null ? shown : answer;
}

export const ThreadFollow = { labelKey, toggled, afterRead, REREAD_AFTER_REPLY_MS } as const;
